module.exports = __webpack_public_path__ + "img/logo.188fbfda.png";